import { styled } from '@material-ui/styles';
import React from 'react';
import { Box, Flex } from '../Layouts';
import { MedText, BoldText, Spacer } from '../Typography';
import colors from '../../theme/colors';
import { Typography } from '@material-ui/core';

export const NotificationRow = styled(Box)(() => ({
  marginBottom: 4,
  marginTop: 4,
  borderRadius: 4,
  padding: 10,
  minHeight: 65,
  overflow: 'hidden',
  cursor: 'pointer',
}));

export const MoreLess = styled('span')(() => ({
  cursor: 'pointer',
  color: colors.primary,
}));

const Notification = ({ title, body, isRead, onNotificationClick, reading, ...rest }) => {
  return (
    <NotificationRow
      style={{ background: isRead ? colors.white : colors.themeBgLightBlue }}
      onClick={onNotificationClick}
      {...rest}
    >
      <Flex alignItems={'center'}>
        <Box>
          <Typography style={{ marginBottom: 2, fontWeight: 600, fontSize: '14px' }}>
            {title}
          </Typography>
          <MedText style={{ marginLeft: 3 }}>
            {reading ? body : body?.slice(0, 80)}
            {body?.length > 80 && (
              <>
                .... <MoreLess>{reading ? 'less' : 'more'}</MoreLess>
              </>
            )}
          </MedText>
        </Box>
        <Spacer />
        {/* <IconButton onClick={onNotificationClick}>
          {reading ? <VisibilityOff /> : <Visibility />}
        </IconButton> */}
      </Flex>
    </NotificationRow>
  );
};

export default Notification;
